import { useEffect, useRef } from "react";
import { useState } from "react";
import styles from "./Slider.module.css"

const Slider = ({ min, max, value, onChange, bidirectional, isDisabled, ...props }) => {
    const [val, setVal] = useState(value);
    const [backgroundSize, setBackgroundSize] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        var percentage = (val - min) * 100 / (max - min);
        !bidirectional &&
            setBackgroundSize(ref.current.offsetWidth * (percentage / 100) + (ref.current.offsetHeight / 2 - ref.current.offsetHeight * (percentage / 100)));
    }, [bidirectional, max, min, setBackgroundSize, val])

    return (
        <div className={styles.wrapper}>
            <span className={styles.label}>{val}</span>
            <input disabled={isDisabled} {...props} style={{ backgroundSize: backgroundSize }} ref={ref} min={min} max={max} value={val} onChange={(e) => { setVal(e.target.value); onChange && onChange(e) }} className={styles.slider} type="range" />
        </div >
    );
}

Slider.defaultProps = {
    min: 0,
    max: 100,
    value: 50
}

export default Slider;